"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var InvolvedObjectsTree_1 = require("./InvolvedObjectsTree");
var CoveragesTree_1 = require("./CoveragesTree");
var DocumentsTree_1 = require("./DocumentsTree");
var CommunicationsTree_1 = require("./CommunicationsTree");
var components_1 = require("@athena-portal/components");
var PolicyActionsTree_1 = require("./PolicyActionsTree");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var ModelVersionComponent_1 = require("../../components/ModelVersionComponent");
var CancellationReasonComponent_1 = require("./CancellationReasonComponent");
var Page_1 = require("../Page");
var operators_1 = require("rxjs/operators");
var InteractionNotification_1 = require("./InteractionNotification");
var CompareInteractionsNotification_1 = require("./CompareInteractionsNotification");
var services_1 = require("@falcon/services");
var SmsTree_1 = require("./SmsTree");
var CoverTierDisplay_1 = require("../../components/CoverTierDisplay");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var DataMappers_1 = require("../../helpers/DataMappers");
var Tree_1 = require("../../components/Tree");
var react_router_dom_1 = require("react-router-dom");
var CoverLevelDisplay_1 = require("../../components/CoverLevelDisplay");
var HomeOwnershipDisplay_1 = require("../../components/HomeOwnershipDisplay");
var PolicyVersionTree = /** @class */ (function (_super) {
    __extends(PolicyVersionTree, _super);
    function PolicyVersionTree(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.mtaTypes = new Map([
            ["mta", "Process MTA"],
            ["mtaAddPermanentDriver", "Added Driver"],
            ["mtaAddTemporaryDriver", "Added Driver"],
            ["mtaRemoveDriver", "Removed Driver"],
            ["mtaEditDriverDetails", "Changed Personal Details"],
            ["mtaAddCar", "Added Car"],
            ["mtaReplaceCar", "Changed Car"],
            ["mtaReinstateAllCars", "Reinstated All Cars"],
            ["mtaReinstateCarCover", "Reinstated Car Cover"],
            ["mtaEditVehicleDetails", "Changed Car Details"],
            ["mtaEditCoverLevel", "Changed Cover Level"],
            ["mtaEditVehicleRegistrationNumber", "Changed Car Registration number"],
            ["mtaAddItem", "Added Item"],
            ["mtaEditItem", "Edited Item"],
            ["mtaEditRentersClaims", "Edited Renters Claims"],
            ["mtaEditRentersCover", "Edited Renters Covers"],
            ["mtaEmploymentStatus", "Edited Employment Status"],
            ["mtaOtherResidents", "Changed Other Residents"],
            ["mtaRemoveItem", "Removed Item"],
            ["mtaReinstateRentersCover", "Reinstated Renters Cover"],
            ["mtaChangeAddress", "Changed Address"],
            ["mtaChangePaymentDay", "Changed Payment Day"],
            ["mtaCarUsage", "Changed Car Usage"],
            ["mtaPayOffBalance", "Pay Off Balance"],
            ["renewalMta", "Renewal MTA"],
            ["mtaChangePolicyHolderAdditionalDetails", "Changed Policy Holder Additional Details"],
            ["mtaChangePolicyHolderDrivingLicenseDetails", "Changed Policy Holder License Details"],
            ["mtaReinstateSubscription", "Reinstate Subscription MTA"],
            ["mtaSupportPortal", "Support Process MTA"],
            ["mtaSupportPortalAnnualEditCustomerDetails", "Support Edited Customer Details"],
            ["mtaSupportPortalAnnualEditNamedDriverDetails", "Support Edited Named Driver Details"],
            ["mtaSupportPortalAnnualReplaceCar", "Support Changed Car"],
            ["mtaSupportPortalAnnualEditCustomerAddress", "Support Changed Customer Address"],
            ["mtaClaimImpact", "Post-Renewal Claim Impact"],
            ["mtaSupportPortalAnnualEditOptionalExtras", "Support Edited Optional Extras"],
            ["mtaNbChangeStartDate", "Changed Start Date"],
            ["mtaChangeDirectDebitCard", "Changed Direct Debit Card"],
            ["mtaSupportPortalAnnualHomeChangeAddress", "Support Edited Home Address"],
            ["mtaSupportPortalEditMTALimits", "Support Edited MTA Limits"],
            ["mtaSupportPortalAnnualAddAdditionalDriver", "Support Add Additional Driver"],
            ["mtaSupportPortalAnnualRemoveDriver", "Support Remove Driver"],
            ["mtaSupportPortalChangePaymentDay", "Support Change Payment Day"]
        ]);
        _this.isOpen = function (policyVersion) {
            return _this.supportPortalTemplates.isTodayBetweenDates(policyVersion.startDate, policyVersion.endDate) || (policyVersion.policyVersionNumber === _this.props.policy.versions[_this.props.policy.versions.length - 1].policyVersionNumber && _this.props.policyVersion.status !== "MTA");
        };
        _this.toggleRenewalCallback = function (autoRenewalFlag, performRenewalFlag) {
            _this.setState({
                autoRenewalFlag: autoRenewalFlag,
                performRenewalFlag: performRenewalFlag
            });
        };
        _this.state = {
            loaded: false,
            communicationsLoaded: false,
            smsLoaded: false,
            renewalCommsLoaded: false,
            hasPendingRenewalVersion: false,
            hasDebt: false,
            autoRenewalFlag: false,
            performRenewalFlag: false,
            suppressRenewal: false
        };
        return _this;
    }
    PolicyVersionTree.prototype.getData = function () {
        var _this = this;
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getPolicyVersionDetails(_this.props.customerReferenceNumber, _this.props.policy.number, _this.props.policyVersion.policyVersionNumber)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (policyVersionDetails) {
                _this.setState({ policyVersionDetails: policyVersionDetails });
                _this.loadInteraction(policyVersionDetails.interactionId);
                _this.loadMarkedForCancellationMaxDate(policyVersionDetails.policyNumber);
                _this.loadCancellationDelayDate(policyVersionDetails.policyNumber);
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getDocuments(_this.props.policy.number, _this.props.policyVersion.policyVersionNumber)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (documents) {
                _this.setState({ documents: documents });
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getCommunications(_this.props.policy.number, _this.props.policyVersion.policyVersionNumber)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (communications) {
                _this.setState({
                    communications: communications,
                    communicationsLoaded: true
                });
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getSms(_this.props.policy.number, _this.props.policyVersion.policyVersionNumber)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (sms) {
                _this.setState({
                    sms: sms,
                    smsLoaded: true
                });
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getRenewalDocuments(_this.props.policy.number, _this.props.policyVersion.policyVersionNumber)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (renewalDocuments) {
                _this.setState({ renewalDocuments: renewalDocuments });
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getRenewalCommunications(_this.props.policy.number, _this.props.policyVersion.policyVersionNumber)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (renewalCommunications) {
                _this.setState({
                    renewalCommunications: renewalCommunications,
                    renewalCommsLoaded: true
                });
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getDelinquencyHistoryByPolicyNumber(_this.props.policy.number)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (delinquencyHistory) {
                _this.setState({ delinquencyHistory: delinquencyHistory });
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getPolicyPropertiesByPropertyKeys(_this.props.policy.number, [services_1.PolicyPropertyEnum.AUTOMATIC_RENEWAL, services_1.PolicyPropertyEnum.PERFORM_RENEWAL, services_1.PolicyPropertyEnum.POLICY_DEBT, services_1.PolicyPropertyEnum.SUPPRESS_RENEWAL])
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (properties) {
                properties.forEach(function (property) {
                    switch (property.key) {
                        case services_1.PolicyPropertyEnum.AUTOMATIC_RENEWAL:
                            _this.setState({ autoRenewalFlag: property.value === "true" });
                            break;
                        case services_1.PolicyPropertyEnum.PERFORM_RENEWAL:
                            _this.setState({ performRenewalFlag: property.value === "true" });
                            break;
                        case services_1.PolicyPropertyEnum.POLICY_DEBT:
                            _this.setState({ hasDebt: property.value === "true" });
                            break;
                        case services_1.PolicyPropertyEnum.SUPPRESS_RENEWAL:
                            _this.setState({ suppressRenewal: property.value === "true" });
                            break;
                        default:
                            break;
                    }
                });
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getRenewalProposal(_this.props.policy.number)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (renewalProposal) {
                if (renewalProposal) {
                    _this.setState({
                        hasPendingRenewalVersion: true
                    });
                }
            });
        });
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getFailedRefundInfo(_this.props.policy.number)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (failedRefundInfo) {
                if (failedRefundInfo) {
                    _this.setState({
                        failedRefundInfo: failedRefundInfo
                    });
                }
            });
        });
        this.setState({
            loaded: true
        });
    };
    PolicyVersionTree.prototype.componentDidMount = function () {
        if (this.isOpen(this.props.policyVersion)) {
            this.getData();
        }
    };
    PolicyVersionTree.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { defaultOpen: this.isOpen(this.props.policyVersion), onItemToggle: function () { return !_this.state.loaded && _this.getData(); }, label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["v", this.props.policyVersion.policyVersionNumber, ' ', "[", (0, commonFunctions_1.formatDate)(this.props.policyVersion.startDate), "]\u2192 [", (0, commonFunctions_1.formatDate)(this.props.policyVersion.endDate), "]", ' ', "(", this.props.policyVersion.status, ")"] }), children: [this.props.children, this.renderInnerFields()] }));
    };
    PolicyVersionTree.prototype.renderInnerFields = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!this.state.policyVersionDetails || !this.state.interaction) {
            if (this.isLoading()) {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            }
            else {
                return (0, jsx_runtime_1.jsx)("div", { children: "Policy version not found!" });
            }
        }
        var createdOnDate = this.state.policyVersionDetails.issueDate;
        var lastCoverEndDate = new Date(this.state.policyVersionDetails.endDate);
        var lastVisibleDate = new Date();
        var minusSevenYears = lastVisibleDate.getFullYear() - 7;
        lastVisibleDate.setFullYear(minusSevenYears);
        var policyOlderSevenYears = lastCoverEndDate < lastVisibleDate;
        var paymentRequired = ((_b = (_a = this.state.interaction.factors) === null || _a === void 0 ? void 0 : _a.additionalPremium) !== null && _b !== void 0 ? _b : 0) > 0;
        var refundRequired = ((_d = (_c = this.state.interaction.factors) === null || _c === void 0 ? void 0 : _c.returnPremium) !== null && _d !== void 0 ? _d : 0) > 0;
        var showMtaType = this.mtaTypes.get(this.state.interaction.process) !== undefined;
        var coverTierChangeWording = (0, commonFunctions_1.getCoverTierChangeWording)(this.state.interaction);
        var renewalCoverChanged = coverTierChangeWording !== "" &&
            this.state.interaction.process === services_1.INTERACTION_PROCESS_RENEWAL;
        var documents = this.getDocuments();
        var communications = this.getCommunications();
        var sms = this.getSms();
        var activeDelinquency = ((_e = this.state.delinquencyHistory) === null || _e === void 0 ? void 0 : _e.some(function (entry) { return entry.status === "Active"; })) || false;
        var refundRequiresInvestigation = (_f = this.state.failedRefundInfo) === null || _f === void 0 ? void 0 : _f.refundsFailedWith0000;
        var refundRequiresCardUpdate = (_g = this.state.failedRefundInfo) === null || _g === void 0 ? void 0 : _g.refundsFailedWith0006;
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(CoverTierDisplay_1.CoverTierDisplay, { product: this.state.interaction.product, tier: this.state.interaction.coverTier }), services_1.productHelper.isHome(this.state.interaction) &&
                    (0, jsx_runtime_1.jsx)(CoverLevelDisplay_1.CoverLevelDisplay, { coverLevel: this.state.interaction.coverLevel }), services_1.productHelper.isHome(this.state.interaction) && ((0, jsx_runtime_1.jsx)(HomeOwnershipDisplay_1.HomeOwnershipDisplay, { realEstate: this.state.interaction.realEstate[0] })), (0, jsx_runtime_1.jsx)(InteractionNotification_1.default, { interaction: this.state.interaction, customer: this.props.customerReferenceNumber }), this.props.policyVersion.policyVersionNumber !== '1' &&
                    (0, jsx_runtime_1.jsx)(CompareInteractionsNotification_1.default, { interaction: this.state.interaction, policyVersions: this.props.policy.versions }), this.state.cancellationDelayedDate && this.props.policy.versions.length - 1 === this.props.index &&
                    (0, jsx_runtime_1.jsx)(Tree_1.Tree, { className: "cancellationDelayed", label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Cancellation delayed until: ", SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(this.state.cancellationDelayedDate)] }) }), showMtaType &&
                    (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["MTA: ", this.mtaTypes.get(this.state.interaction.process), coverTierChangeWording && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [", ", coverTierChangeWording] })] }) }), renewalCoverChanged &&
                    (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Renewal: ", coverTierChangeWording] }) }), paymentRequired &&
                    (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Additional Premium: ", (0, commonFunctions_1.getAmountToDisplay)(this.state.interaction.factors.additionalPremium)] }) }), refundRequired &&
                    (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Refund Premium: ", (0, commonFunctions_1.getAmountToDisplay)(this.refundPremiumAmount())] }) }), (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Created on: ", SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(createdOnDate)] }) }), (0, jsx_runtime_1.jsx)(ModelVersionComponent_1.default, { interaction: this.state.interaction }), this.isMTC(this.state.interaction.process) && this.state.interaction.status === "AGREEMENT"
                    && (0, jsx_runtime_1.jsx)(CancellationReasonComponent_1.default, { interaction: this.state.interaction, policyVersion: this.state.policyVersionDetails }), this.state.interaction && services_1.productHelper.isHomeOrWolfMotor(this.state.interaction) &&
                    ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: ["Automatic Renewal: ", this.state.autoRenewalFlag ? "On" : "Off"] }), !this.state.autoRenewalFlag &&
                                    (0, jsx_runtime_1.jsxs)("div", { children: ["This Year's Renewal: ", this.state.performRenewalFlag ? "On" : "Off"] })] }) })), activeDelinquency && (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("i", { className: "fas fa-exclamation color-red" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/customers/".concat(this.props.customerReferenceNumber, "/policies/").concat(this.props.policy.number, "/directDebitDelinquencyStatusAction"), children: "Delinquency active" })] }) }), refundRequiresInvestigation && (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("i", { className: "fas fa-exclamation color-red" }), " Card refund issue - investigate if refund paid"] }) }), refundRequiresCardUpdate && (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("i", { className: "fas fa-exclamation color-red" }), " Card refund failure - card update required"] }) }), this.state.interaction.source && (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Source: ", this.state.interaction.source] }) }), (0, jsx_runtime_1.jsx)(InvolvedObjectsTree_1.default, { policyVersion: this.state.policyVersionDetails, interaction: this.state.interaction }), (0, jsx_runtime_1.jsx)(CoveragesTree_1.default, { policyVersion: this.state.policyVersionDetails, interaction: this.state.interaction }), (0, jsx_runtime_1.jsx)(DocumentsTree_1.default, __assign({ documents: documents }, this.props)), this.state.communicationsLoaded && this.state.renewalCommsLoaded &&
                    (0, jsx_runtime_1.jsx)(CommunicationsTree_1.default, __assign({ communications: communications, policyNumber: this.props.policy.number, policyVersionNumber: this.props.policyVersion.policyVersionNumber, process: this.state.interaction.process, interactionId: this.state.interaction._id }, this.props)), this.state.smsLoaded && this.state.renewalCommsLoaded &&
                    (0, jsx_runtime_1.jsx)(SmsTree_1.default, __assign({ sms: sms, policyNumber: this.props.policy.number, policyVersionNumber: this.props.policyVersion.policyVersionNumber, process: this.state.interaction.process, interactionId: this.state.interaction._id }, this.props)), (0, jsx_runtime_1.jsx)(PolicyActionsTree_1.default, { policyVersion: this.state.policyVersionDetails, markedForCancellationDueDate: this.state.markedForCancellationMaxDueDate, cancellationDelayedDate: this.state.cancellationDelayedDate, isMTC: this.props.isMTC, customerReferenceNumber: this.props.customerReferenceNumber, interaction: this.state.interaction, policyVersionNumber: this.props.policyVersion.policyVersionNumber, isLatestVersion: !policyOlderSevenYears && this.props.policy.versions.length - 1 === this.props.index, documents: documents, communications: this.state.communications, hasDebt: this.state.hasDebt, autoRenewalFlag: this.state.autoRenewalFlag, hasPendingRenewalVersion: this.state.hasPendingRenewalVersion, performRenewalFlag: this.state.performRenewalFlag, suppressRenewal: this.state.suppressRenewal, parentCallback: this.toggleRenewalCallback, showLoader: this.props.showLoader, hideLoader: this.props.hideLoader })] }));
    };
    PolicyVersionTree.prototype.loadInteraction = function (interactionId) {
        var _this = this;
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .getInteraction(interactionId)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (interaction) {
                _this.setState({ interaction: interaction });
            });
        });
    };
    PolicyVersionTree.prototype.loadMarkedForCancellationMaxDate = function (policyNumber) {
        var _this = this;
        this.context.loadingQueue.increment(function () {
            _this.supportPortalService
                .markedForCancellationMaxDate(policyNumber)
                .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                .subscribe(function (markedForCancellationResponse) {
                _this.setState({ markedForCancellationMaxDueDate: markedForCancellationResponse.dueDate });
            });
        });
    };
    PolicyVersionTree.prototype.loadCancellationDelayDate = function (policyNumber) {
        var _this = this;
        if (this.props.policy.versions.length - 1 === this.props.index) {
            this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .getCancellationDelayDate(policyNumber)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function (cancellationDelayedDate) {
                    _this.setState({ cancellationDelayedDate: cancellationDelayedDate });
                });
            });
        }
    };
    PolicyVersionTree.prototype.refundPremiumAmount = function () {
        if ((0, commonFunctions_1.isAnnualProduct)(this.state.interaction)) {
            return this.state.interaction.paymentDetails.instalmentPlan.upfrontInterestCorrectionRefund ?
                this.state.interaction.factors.returnPremium - this.state.interaction.paymentDetails.instalmentPlan.upfrontInterestCorrectionRefund
                : this.state.interaction.factors.returnPremium;
        }
        else {
            return this.state.interaction.factors.returnPremium;
        }
    };
    PolicyVersionTree.prototype.isMTC = function (process) {
        return process === 'mtc' || process === 'mtcRemoveCar' ||
            process === 'supportPortalSubscriptionCancellation' || process === 'mtcLV' ||
            process === 'supportPortalSubscriptionCancellation';
    };
    PolicyVersionTree.prototype.isLoading = function () {
        return this.context.loadingQueue.size !== 0;
    };
    PolicyVersionTree.prototype.getDocuments = function () {
        var documents = [];
        if (this.state.documents) {
            documents.push.apply(documents, this.state.documents);
        }
        if (this.state.renewalDocuments) {
            documents.push.apply(documents, this.state.renewalDocuments);
        }
        return (0, DataMappers_1.mapDocumentTitles)(documents);
    };
    PolicyVersionTree.prototype.getCommunications = function () {
        var communications = [];
        if (this.state.communications) {
            communications.push.apply(communications, this.state.communications);
        }
        if (this.state.renewalCommunications) {
            communications.push.apply(communications, this.state.renewalCommunications);
        }
        return (0, DataMappers_1.mapCommunicationTitles)(communications);
    };
    PolicyVersionTree.prototype.getSms = function () {
        var sms = [];
        if (this.state.sms) {
            sms.push.apply(sms, this.state.sms);
        }
        return sms;
    };
    PolicyVersionTree.contextType = Page_1.PageContext;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], PolicyVersionTree.prototype, "supportPortalService", void 0);
    PolicyVersionTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], PolicyVersionTree);
    return PolicyVersionTree;
}(React.Component));
exports.default = PolicyVersionTree;
//# sourceMappingURL=PolicyVersionTree.js.map